import { render } from "./WCOutOfStockAlert.vue?vue&type=template&id=627b8b2e"
import script from "./WCOutOfStockAlert.vue?vue&type=script&lang=js"
export * from "./WCOutOfStockAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__